"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  MonocleProvider: () => MonocleProvider,
  useMonocle: () => useMonocle
});
module.exports = __toCommonJS(src_exports);

// src/contexts/MonocleProvider.tsx
var import_react2 = require("react");

// src/utils/useMaxAllowedInstancesGuard.tsx
var import_react = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var instanceCounter = /* @__PURE__ */ new Map();
function useMaxAllowedInstancesGuard(name, error, maxCount = 1) {
  import_react.default.useEffect(() => {
    const count = instanceCounter.get(name) || 0;
    if (count === maxCount) {
      throw new Error(error);
    }
    instanceCounter.set(name, count + 1);
    return () => {
      const currentCount = instanceCounter.get(name) || 0;
      instanceCounter.set(name, Math.max(0, currentCount - 1));
    };
  }, []);
}
function withMaxAllowedInstancesGuard(WrappedComponent, name, error) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || name || "Component";
  const Hoc = (props) => {
    useMaxAllowedInstancesGuard(name, error);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(WrappedComponent, { ...props });
  };
  Hoc.displayName = `withMaxAllowedInstancesGuard(${displayName})`;
  return Hoc;
}

// src/constants.ts
var DOMAIN = "mcl.spur.us";

// src/contexts/MonocleProvider.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var MonocleContext = (0, import_react2.createContext)(null);
var MonocleProviderComponent = ({
  children,
  publishableKey,
  domain = DOMAIN,
  cpd
}) => {
  const [assessment, setAssessment] = (0, import_react2.useState)(void 0);
  const [isLoading, setIsLoading] = (0, import_react2.useState)(true);
  const [error, setError] = (0, import_react2.useState)(null);
  const loadScript = () => {
    return new Promise((resolve, reject) => {
      const existingScript = document.getElementById("_mcl");
      if (existingScript) {
        if (!window.MCL) {
          existingScript.onload = () => resolve();
          existingScript.onerror = () => reject(new Error("Failed to load Monocle script"));
        } else {
          resolve();
        }
        return;
      }
      const script = document.createElement("script");
      script.id = "_mcl";
      script.async = true;
      let src = `https://${domain}/d/mcl.js?tk=${publishableKey}`;
      if (cpd) {
        src += `&cpd=${cpd}`;
      }
      script.src = src;
      script.onload = () => {
        resolve();
      };
      script.onerror = (_e) => {
        console.error("MonocleProvider: Script failed to load");
        reject(new Error("Failed to load Monocle script"));
      };
      document.head.appendChild(script);
    });
  };
  const refresh = (0, import_react2.useCallback)(async () => {
    try {
      setIsLoading(true);
      setError(null);
      if (window.MCL) {
        await window.MCL.refresh();
      } else {
        throw new Error("MCL object not found on window");
      }
    } catch (err) {
      setError(
        err instanceof Error ? err : new Error("Unknown error occurred")
      );
      setIsLoading(false);
    }
  }, []);
  (0, import_react2.useEffect)(() => {
    const initializeMCL = async () => {
      try {
        await loadScript();
        if (window.MCL) {
          await window.MCL.configure({
            onAssessment: (assessment2) => {
              setAssessment(assessment2);
              setIsLoading(false);
            }
          });
          const existingAssessment = window.MCL.getAssessment();
          if (existingAssessment) {
            setAssessment(existingAssessment);
            setIsLoading(false);
          }
        }
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Failed to initialize MCL")
        );
        setIsLoading(false);
      }
    };
    if (!assessment) {
      initializeMCL();
    }
    return () => {
      if (window.MCL) {
        window.MCL.configure({ onAssessment: void 0 });
      }
    };
  }, [publishableKey, domain]);
  const contextValue = (0, import_react2.useMemo)(
    () => ({ assessment, refresh, isLoading, error }),
    [assessment, refresh, isLoading, error]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(MonocleContext.Provider, { value: contextValue, children });
};
var MonocleProvider = withMaxAllowedInstancesGuard(
  MonocleProviderComponent,
  "MonocleProvider",
  "Only one instance of MonocleProvider is allowed"
);
var useMonocle = () => {
  const context = (0, import_react2.useContext)(MonocleContext);
  if (!context) {
    throw new Error("useMonocle must be used within a MonocleProvider");
  }
  return context;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MonocleProvider,
  useMonocle
});
//# sourceMappingURL=index.js.map